<!-- Header Template Included - Starts -->
<app-header></app-header>
<!-- Header Templated Included - Ends -->
<section class="dashboard_container">
  <div class="container-fluid">
    <div class="row no-pad mar-btm-40">
      <div class="col-md-3 mar-btm-40">
        <div class="dashboard_cards" routerLink="/poDaily" id="volActuals">
          <div class="card_title text-center">
            {{'PURCHASE ORDERS' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/vol_actual.png">
          </div>
        </div>
      </div>

      <div class="col-md-3 mar-btm-40">
        <div class="dashboard_cards" routerLink="/poFCMonthly" id="volFC">
          <div class="card_title text-center">
            {{'FORECASTS' | translate}}
          </div>
          <div class="card_icon text-center">
            <img src="../../../assets/vol_fc.png">
          </div>
        </div>
      </div>
      <div class="dashboard_cards" routerLink="/poExports" id="volFC">
        <div class="card_title text-center">
          {{'EXPORT PAST/FUTURE DELIVERIES' | translate}}
        </div>
        <div class="card_icon text-center">
          <img src="../../../assets/location-point.png">
        </div>
      </div>
    </div>
  </div>
</section>